import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../../environments/environment";
import {UtilService} from "../../util-services/util.service";

interface Attribute {
    attributeIdentifier: string;
    attributeValue: any;
}

export interface CustomOutcomeAttributes {
    type: string;
    attributes: Attribute[];
}

@Injectable({
    providedIn: "root",
})
export class CustomOutcomeAttributesService {
    private readonly apiBaseUrl = `${environment.apiUrlPrefix}`;

    constructor(
        private http: HttpClient,
        private utils: UtilService
    ) {
    }

    getSettings(campaignId: string): Observable<any> {
        const url = `${this.apiBaseUrl}/campaign/${campaignId}/integrations/effective-custom-attributes-schema`;
        return this.http.get<any>(url, this.utils.getHeaders());
    }
}
